import {NOTIFIES} from "./types"
const notifies = notify =>({
    type: NOTIFIES,
    payload: { notify },  
})

export default notifies